
const fire = (eventable_id, eventable_type, type, active, access_token, user_str_id) => {
    return new Promise((resolve, reject) => {
        axios.post('/api/event/fire', {
            eventable_id: eventable_id,
            eventable_type: eventable_type,
            type: type,
            active: active
        }, {
            headers: {
                Authorization: access_token ? ('Bearer ' + access_token) : null,
                Accept: 'application/json'
            },
            params: { user_str_id: user_str_id ? user_str_id : null }
        }).then(res => {
            resolve(res.data)
        }, res => {
            reject(res.response)
        })
    })
}


export {
    fire
}